import { render, staticRenderFns } from "./PaneRenderer.vue?vue&type=template&id=19fa685c&scoped=true"
import script from "./PaneRenderer.vue?vue&type=script&lang=ts"
export * from "./PaneRenderer.vue?vue&type=script&lang=ts"
import style0 from "./PaneRenderer.vue?vue&type=style&index=0&id=19fa685c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa685c",
  null
  
)

export default component.exports